const queryString = {
  parse: (str: string): { [key: string]: any } => {
    const params = new URLSearchParams(str);
    const paramObj: { [key: string]: any } = {};
    params.forEach((value, key) => {
      paramObj[key] = value;
    });
    return paramObj;
  },
  stringify: (params?: { [key: string]: any }): string =>
    params ? new URLSearchParams(params).toString() : '',
};

export default queryString;
